// Sample picture data for our store
const picturesData = [
  {
    id: 1,
    name: "Beach Sunset",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1460627390041-532a28402358?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Beautiful sunset at the beach",
  },
  {
    id: 2,
    name: "Mountain Landscape",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1604223190546-a43e4c7f29d7?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Breathtaking mountain landscape",
  },
  {
    id: 3,
    name: "City Skyline",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1575380591643-b2c92368dc6d?q=80&w=1462&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Modern city skyline with skyscrapers",
  },
  {
    id: 4,
    name: "Forest Path",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1420582282039-a6d11404cb66?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Serene path through a lush forest",
  },
  {
    id: 5,
    name: "Ocean Waves",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Powerful ocean waves with clouds",
  },
  {
    id: 6,
    name: "Desert Dunes",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1542401886-65d6c61db217?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Golden desert dunes at sunset",
  },
  {
    id: 7,
    name: "Aurora Borealis",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1579033461380-adb47c3eb938?q=80&w=1528&auto=format&fit=crop&ixlib=rb-4.1.0",
    description: "Stunning northern lights over a snowy landscape",
  },
  {
    id: 8,
    name: "Tropical Waterfall",
    price: 0.0000001,
    image:
      "https://images.unsplash.com/photo-1494472155656-f34e81b17ddc?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0",
    description: "Lush tropical waterfall in an exotic rainforest",
  },
];

export default picturesData;
